module.exports = new __parcel__URL__("turkey.a79defab.svg").toString();